export const TENANT_OPEN_NETWORK_DOMAINS_RESET_STATE = 'TENANT_OPEN_NETWORK_DOMAINS_RESET_STATE';
export const TENANT_OPEN_NETWORK_DOMAINS_CURRENT_ITEM = 'TENANT_OPEN_NETWORK_DOMAINS_CURRENT_ITEM';

export const TENANT_OPEN_NETWORK_DOMAINS_REQUEST_LOADING = 'TENANT_OPEN_NETWORK_DOMAINS_REQUEST_LOADING';
export const TENANT_OPEN_NETWORK_DOMAINS_REQUEST_SUCCESS = 'TENANT_OPEN_NETWORK_DOMAINS_REQUEST_SUCCESS';
export const TENANT_OPEN_NETWORK_DOMAINS_REQUEST_FAILED = 'TENANT_OPEN_NETWORK_DOMAINS_REQUEST_FAILED';

export const TENANT_OPEN_NETWORK_DOMAINS_CURRENT_ACTION = 'TENANT_OPEN_NETWORK_DOMAINS_CURRENT_ACTION';
export const TENANT_OPEN_NETWORK_DOMAINS_RESET_ACTION = 'TENANT_OPEN_NETWORK_DOMAINS_RESET_ACTION';